import {
	getAttributeOrThrow,
	getCartUpdateForRitualCTA,
	PUB_SUB_EVENTS,
	publish,
	qsOptional,
} from '@/scripts/core/global'
import { IngredientsSlider } from '@/scripts/theme/ingredients-slider'
import { routes } from '@/scripts/setup'
import {
	CartPartialWithSections,
	getDOMCartSectionApiIds,
	renderResponseToCartDrawer,
} from '@/scripts/core/cart-functions'

export class ProductRitual extends IngredientsSlider {
	static override htmlSelector = 'product-ritual'
	cta?: {
		primaryCtaButton: HTMLButtonElement
		primaryVariantId: number
		ritualVariantIds: number[]
	}

	constructor() {
		super()
		this.cta = this.getCta()
		if (!this.cta) {
			return
		}
		this.cta.primaryCtaButton.addEventListener(
			'click',
			this.addRitualToCart.bind(this)
		)
	}

	async addRitualToCart() {
		if (!this.cta) {
			throw new Error('No CTA found')
		}
		const updates = getCartUpdateForRitualCTA(
			this.cta.primaryVariantId,
			this.cta.ritualVariantIds
		)
		const response = await fetch(`${routes.cart_update_url}`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				updates,
			}),
		})

		if (!response.ok) {
			throw new Error('Failed to add to cart')
		}

		publish(PUB_SUB_EVENTS.cartUpdate, {
			source: 'product-form',
			productVariantId: this.cta?.primaryVariantId,
		})

		const updatedSectionsResponse = await fetch(
			`/?sections=${getDOMCartSectionApiIds()?.join(',')}`
		)
		const updatedSections = await updatedSectionsResponse.json()
		const cart = {
			sections: updatedSections,
			items: [{ variant_id: this.cta.primaryVariantId }],
		} as CartPartialWithSections
		renderResponseToCartDrawer(cart, undefined)
	}

	getCta() {
		const primaryCtaButton = qsOptional<HTMLButtonElement>(
			'[data-ritual-primary-cta]',
			this
		)
		if (!primaryCtaButton) {
			return undefined
		}
		const primaryVariantId = parseInt(
			getAttributeOrThrow('data-ritual-primary-cta', primaryCtaButton)
		)
		const variantIdAttr = getAttributeOrThrow(
			'data-variants-in-ritual',
			this
		)
		const ritualVariantIds = variantIdAttr
			.split(',')
			.map((id) => parseInt(id))
		return {
			primaryCtaButton,
			primaryVariantId,
			ritualVariantIds,
		}
	}

	override connectedCallback() {
		super.connectedCallback()
	}
}
